import React from "react";
import ReactDOM from "react-dom";
import { SnackbarContent, Slide, Snackbar as MaterialSnackbar } from "@material-ui/core";
import { SnackbarContext } from "./context";


const SUCCESS_COLOR = "#2EB6C8";
const ERROR_COLOR = "#A3030A";
const ALERT_COLOR = "#616161";
const WARNING_COLOR = "#fcf8e3";
const WARNING_TEXT_COLOR = "#8a6d3b";

const Snackbar = (): React.ReactPortal => {
  const element = document.querySelector("#snackbar-root");
  const { state, setState } = React.useContext(SnackbarContext);
  let color = ALERT_COLOR;

  if (!element) throw new Error("#snackbar-root missing");

  switch (state.status) {
    case "warning":
      color = WARNING_COLOR;
      break;
    case "alert":
      color = ALERT_COLOR;
      break;
    case "success":
      color = SUCCESS_COLOR;
      break;
    case "error":
      color = ERROR_COLOR;
      break;
    default:
      color = ALERT_COLOR;
  }

  const style: React.CSSProperties = { backgroundColor: color };

  if (state.status === "warning") style.color = WARNING_TEXT_COLOR;

  return ReactDOM.createPortal(
    <MaterialSnackbar
      open={state.isOpen}
      onClose={() => setState({ ...state, isOpen: false })}
      autoHideDuration={state.duration}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      TransitionComponent={Slide}
    >
      <SnackbarContent className="snackbar" message={state.message} style={style} />
    </MaterialSnackbar>,
    element,
  );
};

export default Snackbar;
